import {redirect} from '@tanstack/react-router';
import {useDeviceSelectors} from 'react-device-detect';
import {RouterGuardOtps} from '@/libs/router';

const MOBILE_GUARD_EXCLUDES = ['/plans', '/settings', '/team', '/agents/mobile'];

export const mobileGuard = ({location}: RouterGuardOtps) => {
  const [selectors] = useDeviceSelectors(window.navigator.userAgent);
  const isDesktop = !selectors.isMobile && !selectors.isTablet;

  if (MOBILE_GUARD_EXCLUDES.some((path) => location.pathname.startsWith(path))) {
    return;
  }
  if (!isDesktop) {
    throw redirect({to: '/agents/mobile'});
  }
};
